import { render, staticRenderFns } from "./QuotationForm.component.vue?vue&type=template&id=5e8559e7&scoped=true"
import script from "./QuotationForm.component.vue?vue&type=script&lang=js"
export * from "./QuotationForm.component.vue?vue&type=script&lang=js"
import style0 from "./QuotationForm.component.vue?vue&type=style&index=0&id=5e8559e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8559e7",
  null
  
)

export default component.exports